import { Configuration, ReferencialNodesApi } from "@socotec.io/referencial-sdk";
import { useOidcStore } from "vue3-oidc";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_REFERENCIAL_REST_API_URL,
  accessToken: () => `Bearer ${useOidcStore().state.value.token}`,
  headers: {
    "Accept-Encoding": "gzip, deflate, br",
  },
});
const referencialNodeClient = new ReferencialNodesApi(configuration);

let referentialVersion = null;

const fetchReferentialVersion = async () => {
  const response = await referencialNodeClient.version({});
  referentialVersion = response.versionNumber;
  return referentialVersion;
};

export default async () => {
  if (referentialVersion) {
    return referentialVersion;
  }
  return await fetchReferentialVersion();
};
